import React from 'react';

import List from './template-message/List'

function TemplateMessage(){
	return(
	
			<List/>
			

	);
}

export default TemplateMessage;